import { useLanguage } from 'contexts/LanguageContext';

import { Box, Paper, Typography, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const languages = [
	{ code: 'en', name: 'English', nativeName: 'English' },
	{ code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
	{ code: 'es', name: 'Spanish', nativeName: 'Español' },
	{ code: 'it', name: 'Italian', nativeName: 'Italiano' },
	{ code: 'ae', name: 'Arabic', nativeName: 'Arabic' },
];

const LanguagesSwitcher = () => {
	const { locale, changeLocale, t } = useLanguage();

	const rowStyle = (langCode) => ({
		cursor: 'pointer',
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '16px',
		marginBottom: '12px',
		border: locale === langCode ? `2px solid #1976d2` : `1px solid #e0e0e0`,
		borderRadius: '8px',
		transition: 'background-color 0.2s',
		'&:hover': {
			backgroundColor: '#f5f5f5'
		}
	});

	return (
		<Box sx={{ padding: '24px', maxWidth: '700px', margin: 'auto' }}>
			<Typography variant="h4" gutterBottom>
				{t('settings.languages.title')}
			</Typography>
			<Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
				{t('settings.languages.description')}
			</Typography>
			<Stack spacing={2}>
				{languages.map((lang) => (
					<Paper
						elevation={1}
						sx={rowStyle(lang.code)}
						key={lang.code}
						onClick={() => changeLocale(lang.code)}
					>
						<Box>
							<Typography variant="h6" component="div">
								{lang.name}
							</Typography>
							<Typography color="text.secondary">
								{lang.nativeName}
							</Typography>
						</Box>
						{locale === lang.code && (
							<CheckCircleIcon color="primary" sx={{ fontSize: 28 }} />
						)}
					</Paper>
				))}
			</Stack>
		</Box>
	);
};

export default LanguagesSwitcher;
